module.exports = __webpack_public_path__ + "static/img/img.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img.png
// module id = Tp5f
// module chunks = 14